import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { LOCALIZATION_KEY } from '../../constants'
import DesktopImage from '../../assets/rd-welcome-desktop.png'
import MobileImage from '../../assets/rd-welcome-mobile.png'
import {
  Container,
  Title,
  ImageContainer,
  Image,
  ListWrapper,
  ListItemWrapper,
  ListItemIcon,
  ListItemText,
  GetStartedButton,
  ContentWrapper,
} from './styles'

interface Props {
  handleClickPromoView?: () => void
}

export const DistributionPromo = ({ handleClickPromoView }: Props) => {
  const { i18n } = useI18n()
  const { isAboveTablet } = useMediaQueries()

  return (
    <Container>
      <Title>{i18n.t(`${LOCALIZATION_KEY}.distribution_promo.title`)}</Title>
      <ContentWrapper>
        <ListWrapper>
          <ListItemWrapper>
            <ListItemIcon />
            <ListItemText
              dangerouslySetInnerHTML={{
                __html: i18n.t(`${LOCALIZATION_KEY}.distribution_promo.item_1`),
              }}
            />
          </ListItemWrapper>
          <ListItemWrapper>
            <ListItemIcon />
            <ListItemText
              dangerouslySetInnerHTML={{
                __html: i18n.t(`${LOCALIZATION_KEY}.distribution_promo.item_2`),
              }}
            />
          </ListItemWrapper>
          <ListItemWrapper>
            <ListItemIcon />
            <ListItemText
              dangerouslySetInnerHTML={{
                __html: i18n.t(`${LOCALIZATION_KEY}.distribution_promo.item_3`),
              }}
            />
          </ListItemWrapper>
          <ListItemWrapper>
            <ListItemIcon />
            <ListItemText
              dangerouslySetInnerHTML={{
                __html: i18n.t(`${LOCALIZATION_KEY}.distribution_promo.item_4`),
              }}
            />
          </ListItemWrapper>
        </ListWrapper>
        <ImageContainer>
          <Image src={isAboveTablet ? DesktopImage : MobileImage} />
        </ImageContainer>
      </ContentWrapper>

      {!isAboveTablet && (
        <GetStartedButton onClick={handleClickPromoView}>
          {i18n.t(`${LOCALIZATION_KEY}.distribution_promo.button_text`)}
        </GetStartedButton>
      )}
    </Container>
  )
}
